module.exports = __webpack_public_path__ + "img/shop4.4801b593.png";